import * as React from 'react'
import styled, { keyframes } from 'styled-typed'
import { useTranslation } from 'translations'

const flash = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
`

const MessageElement = styled.div`
    margin: 0.8em 0.5em;
    color: ${(props) => props.theme.colors.status.error};
    &.flash {
        opacity: 0;
        animation: ${flash} linear 3s 1;
    }
`

interface ErrorMessageProps {
    errType?: string
    errText?: string
    flash?: boolean
    style?: React.CSSProperties
}

export const ErrorMessage = (props: ErrorMessageProps) => {
    const { t } = useTranslation()
    function getErrorText() {
        switch (props.errType) {
            case 'minOne':
                return t('uiComponents.studio.form.errors.minOne')
            case 'url':
                return t('uiComponents.studio.form.errors.url')
            case 'notEmpty':
                return t('uiComponents.studio.form.errors.notEmpty')
            case 'partOfUrl':
                return t('uiComponents.studio.form.errors.partOfUrl')
            case 'outOfRange':
                return t('uiComponents.studio.form.errors.outOfRange')
            default:
                return t('uiComponents.studio.form.errors.default')
        }
    }
    return (
        <MessageElement className={props.flash ? 'flash' : ''} style={props.style}>
            {props.errText || getErrorText()}
        </MessageElement>
    )
}
